import React from 'react'
import './index.scss'

const WorkMergePrimarySelectionHeader = () => (
    <div className="work-merge-panel-header">
        <>
            <h4>Work Merge Process</h4>
            <p>
                You are reporting that the following works represent the same musical composition. Review the details
                carefully before submitting.
            </p>
            <p>
                Select which work you would like to be used as the primary work to merge works into. Any work titles
                that are not selected will automatically become an alternative title.
            </p>
        </>
    </div>
)
export default WorkMergePrimarySelectionHeader
